<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <span class="title">Projects</span>
      </v-col>
      <v-col
        class="text-right"
        cols="2"
      >
        <project-create-update
          v-if="projects.length > 0 && isInitiated"
          @change="getProjects"
        >
          <v-icon>mdi-plus</v-icon>&nbsp;Create
        </project-create-update>
      </v-col>
    </v-row>
    <!-- Start No Project -->
    <v-slide-y-transition
      class="row"
      leave-absolute
      group
      tag="div"
    >
      <v-col
        v-if="!isInitiated"
        :key="0"
      >
        <loading-projects-placeholder />
      </v-col>
      <v-col
        v-else-if="projects.length > 0 && isInitiated"
        :key="2"
        cols="12"
      >
        <div class="row mx-1" />
        <v-list
          :two-line="true"
          subheader
        >
          <v-subheader>
            <v-spacer /><span
              class="mr-5"
            >Updated &emsp; Status &emsp;&emsp;</span>
          </v-subheader>
          <v-list-item-group>
            <v-divider />
            <v-list-item
              v-for="(item, i) in projects"
              :key="i"
              :to="'/projects/' + item.id"
            >
              <v-list-item-avatar>
                <v-icon>mdi-folder-outline</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title v-text="item.name" />
                <v-list-item-subtitle
                  v-if="item.description"
                  class="mt-2"
                  v-text="item.description"
                />
              </v-list-item-content>
              <v-list-item-content class="text-right mr-5">
                <v-list-item-title
                  class="grey--text caption"
                  v-text="item.updated_at"
                />
              </v-list-item-content>
              <v-list-item-avatar class="mb-3">
                <v-switch
                  v-model="item.is_active"
                  disabled
                  color="accent"
                />
              </v-list-item-avatar>
              <v-list-item-action
                @click.stop
                @click.prevent
              >
                <v-menu
                  bottom
                  left
                  offset-y
                >
                  <template v-slot:activator="{ on }">
                    <v-btn
                      icon
                      v-on="on"
                      @click.stop
                      @click.prevent
                    >
                      <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                  </template>
                  <v-list dense>
                    <v-list-item-group>
                      <v-list-item
                        @click="projectToEdit = item"
                      >
                        <v-list-item-icon>
                          <v-icon>
                            mdi-pencil-outline
                          </v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title>
                            Edit
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item
                        @click="projectToDelete = item"
                      >
                        <v-list-item-icon>
                          <v-icon>
                            mdi-delete-outline
                          </v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title>
                            Delete
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list-item-group>
                  </v-list>
                </v-menu>
              </v-list-item-action>
            </v-list-item>
            <v-divider />
          </v-list-item-group>
        </v-list>
      </v-col>
      <v-col
        v-else
        :key="1"
        cols="12"
      >
        <v-card
          class="mx-auto transparent text-center"
          flat
        >
          <v-img
            max-height="250"
            src="/img/starting_project.png"
            contain
          />
          <v-card-text class="headline">
            Here's where your work begins
          </v-card-text>
          <v-card-text>
            I'm a thing. But, like most politicians, he promised
            more than he could deliver. You won't have time for
            sleeping, soldier, not with all the bed making you'll be
            doing.
          </v-card-text>
          <project-create-update @change="getProjects">
            <span>Create New Project</span>
            <!-- <template v-slot:activator="{ on }">
              <v-card-actions>
                <v-btn
                  class="ma-2"
                  tile
                  color="primary"
                  outlined
                >
                  <v-icon left>
                    mdi-pencil
                  </v-icon>Create Project
                </v-btn>
                <v-btn text>
                  Resources
                </v-btn>
              </v-card-actions>
            </template> -->
          </project-create-update>
        </v-card>
      </v-col>
      <!-- End No Project -->
    </v-slide-y-transition>
    <v-row>
      <v-col>
        <v-dialog
          :value="projectToDelete != null"
          max-width="340"
        >
          <v-card>
            <v-card-title class="headline">
              Delete Project
            </v-card-title>
            <v-card-text>
              Are you sure you want to delete it? You won't be
              able to recover the project you wish to delete.
            </v-card-text>
            <v-card-actions>
              <div class="flex-grow-1" />
              <v-btn
                text
                @click="projectToDelete = null"
              >
                Cancel
              </v-btn>
              <v-btn
                class="ma-2"
                text
                outlined
                color="red"
                @click.native="deleteProject"
              >
                Delete
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <project-create-update
          :project="projectToEdit"
          is-editing
          @change="getProjects"
          @close="projectToEdit = null"
        />
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
  import LoadingProjectsPlaceholder from './../../../UIComponents/Placeholders/LoadingProjectsPlaceholder'
  import ProjectCreateUpdate from './ProjectCreateUpdate'
  import ProjectService from './services/ProjectService'

  export default {
    components: {
      'project-create-update': ProjectCreateUpdate,
      LoadingProjectsPlaceholder,
    },
    data () {
      return {
        projectToDelete: null,
        projectToEdit: null,
        isInitiated: false,
        isLoading: false,
        projects: [],
      }
    },
    mounted () {
      this.getProjects()
    },
    methods: {
      getProjects () {
        ProjectService.list(this).then(r => {
          this.projects = r.data.results
          if (!this.isInitiated) this.isInitiated = true
        })
      },
      deleteProject () {
        ProjectService.delete(this, this.projectToDelete.id).then(r => {
          this.projects.splice(
            this.projects.indexOf(this.projectToDelete),
            1
          )
          this.projectToDelete = null
        })
      },
      cloneProject () {
        this.$store.commit('push', {
          msg: 'Cloning projects is not available...',
          color: 'warning',
        })
      },
    },
  }
</script>
<style scoped></style>
